export const arr = [
  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "実稼働時間",
    cols: "0",
    value: "終了時刻,開始時刻",
    init: "",
    rule: ",0,required,required,dateSub,,,,,,,,,,,,,,,,,,,,,,,,",
  },
  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "中断時間",
    cols: '{"lg":4,"md":4,"sm":4,"xs":4}',
    value: "集計対象,サブページ指定FormID",
    init: "",
    rule: ",0,required,required,total,,,,,,,,,,,,,,,,,,,,,,,,",
  },
  {
    form_id: 0,
    type: 1,
    name: "テキストエリア",
    label: "稼働時間",
    cols: "0",
    value: "総合計時間,中断時間",
    init: "",
    rule: ",0,required,required,timeSub,,,,,,,,,,,,,,,,,,,,,,,,",
  },
];

export default arr;
